
export type ChatRoomResponseBasicInfoAllOfTwoType = typeof ChatRoomResponseBasicInfoAllOfTwoType[keyof typeof ChatRoomResponseBasicInfoAllOfTwoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatRoomResponseBasicInfoAllOfTwoType = {
  DIRECT: 'DIRECT',
  GROUP: 'GROUP',
} as const;
